import React from 'react'
import { Separator, Skeleton } from '@fs/zion-ui'
import SkeletonAnimationSyncDecorator from '../../../common/SkeletonAnimationSyncDecorator'

export default function LifeSketchLoading(): JSX.Element {
  return (
    <SkeletonAnimationSyncDecorator>
      <Skeleton.Paragraph lineCount={2} size="md" />
      <Separator size="nano" />
    </SkeletonAnimationSyncDecorator>
  )
}
